module.exports = __webpack_public_path__ + "static/media/light-theme-vehicle-count.89ef3255.svg";